const doc = [({"ja":({"adminComponentCompanyPayment":({"companyPaymentIndexTitle":"支払い一覧", "companyPaymentSummaryIndexTitle":"支払い概要", "showTargetBooking":"対象の予約を表示する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;